export default "__VITE_ASSET__CAkAbg8q__"